/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import DtModObservable from '../../../Game/DtModObservable';
import InjectableComponent from '../ComponentReference/InjectableComponent';
import { AnimationType } from './AnimationWrapper';
import IAnimate from './IAnimate';

export default abstract class AnimationInstanceBase<T extends AnimationType> implements IAnimate
{
    public static readonly StoppedEvent: string = 'Animation.Stopped';

    protected animation: T = null;
    protected options: IAnimationOptions = null;

    public abstract Play(): Promise<any>;

    public abstract Stop(): AnimationInstanceBase<T>;
    private _hasSetContext: boolean = false;

    private _dtModRef: InjectableComponent<DtModObservable> = new InjectableComponent();
    protected get dtMod(): number
    {
        if (!this._hasSetContext)
        {
            this._dtModRef.SetContext(DtModObservable);
            this._hasSetContext = true;
        }
        return this._dtModRef.HasValue()
            ? this._dtModRef.Value.Value
            : 1;
    }

    protected emitStopped(): AnimationInstanceBase<T>
    {
        this.animation.node.emit(AnimationInstanceBase.StoppedEvent);
        return this;
    }

    constructor(value: T, options: IAnimationOptions = {})
    {
        this.animation = value;

        options.Loop = options.Loop === true;
        options.Speed = options.Speed > 0 ? options.Speed : 1;
        this.options = options;
    }

    protected hasDefaultAnimation(): boolean
    {
        return this.options && !!this.options.DefaultAnimation;
    }
}

export interface IAnimationOptions
{
    Loop?: boolean;
    AnimationName?: string;
    DefaultAnimation?: string;
    Speed?: number; // TODO: Implement for effect sequence.
}
